import { render, staticRenderFns } from "./employeeLimit.vue?vue&type=template&id=91003142&scoped=true&"
import script from "./employeeLimit.vue?vue&type=script&lang=js&"
export * from "./employeeLimit.vue?vue&type=script&lang=js&"
import style0 from "./employeeLimit.vue?vue&type=style&index=0&id=91003142&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91003142",
  null
  
)

export default component.exports